import Typography from '@mui/material/Typography';
import Stack from '@mui/system/Stack';
import React from 'react';
import { AuthData } from '../../context/auth';
import { PolicyData } from '../../context/policy';
import {
	PremiumReportData,
	withPremiumReportContext,
} from '../../context/premiumReport';
import { capitalize } from '../../util/util';
import { StyledSectionContainer } from '../common';
import DisplayCard from '../DisplayCard';

interface Props {
	authData: AuthData;
	policyData: PolicyData;
	premiumReportData: PremiumReportData;
}

const Overview = (props: Props) => {
	const { premiumReportData, policyData, authData } = props;
	const { premiumReport, replaceMode } = premiumReportData;
	const { policy } = policyData;

	// don't show overview panel when in replace mode
	if (replaceMode) {
		return null;
	}

	const renderDetailCard = (title: string, data: string, link?: string) => {
		return <DisplayCard title={title} value={data} link={link} />;
	};

	return (
		<>
			<StyledSectionContainer>
				<Stack spacing={2}>
					<Typography id='premium_report_id' variant='h3' gutterBottom>
						{`Premium Report ${premiumReport.displayId}`}
					</Typography>
					<Stack spacing={2} direction='row'>
						{renderDetailCard('Premium Report Id', premiumReport.displayId)}
						{renderDetailCard('Report Name', policy.premiumReportName)}
						{renderDetailCard(
							'Created Date',
							authData.getFormattedDate(premiumReport.createdTimestamp),
						)}
						{renderDetailCard(
							'Last Modified Date',
							authData.getFormattedDate(premiumReport.updatedTimestamp),
						)}
						{premiumReport.replacedByLocator
							? renderDetailCard(
									'Replaced By',
									premiumReport.replacedByLocator,
									`./../${premiumReport.replacedByLocator}/details`,
							  )
							: null}
						{premiumReport.replacementOfLocator
							? renderDetailCard(
									'Replacement Of',
									premiumReport.replacementOfLocator,
									`./../${premiumReport.replacementOfLocator}/details`,
							  )
							: null}
						{renderDetailCard('Status', capitalize(premiumReport.state))}
					</Stack>
				</Stack>
			</StyledSectionContainer>
		</>
	);
};

export default withPremiumReportContext<Props>(Overview);
